import {SettingsSidebar} from "@src/components/settings-sidebar";
import {createFileRoute, Outlet} from "@tanstack/react-router";
import {SidebarInset, SidebarProvider} from "@zeg/ui/Sidebar";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings"
)({component: RouteComponent});

function RouteComponent() {
  return (
    <SidebarProvider className="bg-secondary" enableKeyboardShortcut={false}>
      <SettingsSidebar />
      <SidebarInset className="p-2">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
